import { Lightning } from '@lightningjs/sdk'

import { transparent } from '../../constants/colors'
import { getDevSettings } from '../../utils/settingsUtils'
import { DevSettingsItem } from './DevSettingsItem'

export default class DevSettingsMenu extends Lightning.Component {
  private _currentSettingIndex = 0

  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: transparent,
      flex: { direction: 'column' },
      collision: true,
    }
  }

  _init() {
    this.patch({
      children: getDevSettings().map((item, index) => {
        return {
          type: DevSettingsItem,
          data: item,
          flexItem: { marginBottom: 24 },
          settingIndex: index,
        }
      }),
    })
  }

  get currentSettingIndex() {
    return this._currentSettingIndex
  }

  get currentSetting() {
    return this.childList.getAt(this.currentSettingIndex) as DevSettingsItem
  }

  get totalSettings() {
    return this.childList.length
  }

  _getFocused() {
    return this.currentSetting
  }

  _handleDown() {
    if (this.currentSettingIndex === this.totalSettings - 1) {
      return false
    } else {
      this._currentSettingIndex++
    }
  }

  _handleUp() {
    if (this.currentSettingIndex === 0) {
      return false
    } else {
      this._currentSettingIndex--
    }
  }

  $updateFocusByHover({ settingIndex }) {
    this._currentSettingIndex = settingIndex
    this._refocus()
  }
}
